'use client';

import { __awaiter, __generator, __spreadArray, __assign } from '../_virtual/_tslib.js';
import { NAVIGOS_COMPANY_ID, ELanguage, INTERNATIONAL_CITY_ID, VIETNAM_COUNTRY_ID, FORTIWEB_IP, pathPage } from './constants.js';
import translations from './translations.js';

function filterInt(value) {
    if (/^[-+]?(\d+|Infinity)$/.test(value)) {
        return Number(value);
    }
    else {
        return NaN;
    }
}
function isMobile() {
    if (typeof window !== 'undefined') {
        return window.innerWidth < 768;
    }
    return false;
}
function isDesktop() {
    if (typeof window !== 'undefined') {
        return window.innerWidth >= 992;
    }
    return false;
}
// Hex to RGBA with 20% opacity
function ConvertHexToRgbA(hex, opacity) {
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        var c = hex.substring(1).split('');
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ",".concat(opacity, ")");
    }
    throw new Error('Bad Hex');
}
function addCommaToNumber(number) {
    var nums = number.toString().replace(/,/g, '');
    if (!nums || nums.endsWith('.'))
        return number.toString();
    return parseFloat(nums).toLocaleString('en-US');
}
function getNumberFromString(string) {
    if (string) {
        return Number(string.replace(/,/g, ''));
    }
    else
        return '';
}
function encodeKeyword(rawKeyword) {
    var blackList = [
        { regex: /C#/gi, replace: 'C_sharp' },
        {
            regex: /C\+\+/gi,
            replace: 'C_plus_plus'
        },
        { regex: /[[\]\\/:~^?!()><"'@%|{}`*#]/gi, replace: ' ' },
        { regex: /&/gi, replace: encodeURIComponent('&') }
    ];
    var tempkeyword;
    for (var i in blackList) {
        rawKeyword = rawKeyword.replace(blackList[i].regex, blackList[i].replace);
    }
    do {
        tempkeyword = rawKeyword;
        rawKeyword = tempkeyword.replace('  ', ' ');
    } while (tempkeyword !== rawKeyword);
    rawKeyword = rawKeyword.replace(/[-]{1,}/g, '--');
    rawKeyword = rawKeyword.trim();
    return rawKeyword.replace(/ /g, '-');
}
/**
 * Transform all characters with accent into latin, e.g. `Ô kìa Con vịt` to `o kia con vit`
 * @param text - the text you want to transform
 */
function transformToLatin(text, isUrl) {
    if (isUrl === void 0) { isUrl = false; }
    text = text.toString().toLowerCase().trim();
    var sets = [
        { to: 'a', from: '[ÀÁÂÃÄÅÆĀĂĄẠẢẤẦẨẪẬẮẰẲẴẶἀ]' },
        { to: 'c', from: '[ÇĆĈČ]' },
        { to: 'd', from: '[ÐĎĐÞ]' },
        { to: 'e', from: '[ÈÉÊËĒĔĖĘĚẸẺẼẾỀỂỄỆ]' },
        { to: 'g', from: '[ĜĞĢǴ]' },
        { to: 'h', from: '[ĤḦ]' },
        { to: 'i', from: '[ÌÍÎÏĨĪĮİỈỊ]' },
        { to: 'j', from: '[Ĵ]' },
        { to: 'ij', from: '[Ĳ]' },
        { to: 'k', from: '[Ķ]' },
        { to: 'l', from: '[ĹĻĽŁ]' },
        { to: 'm', from: '[Ḿ]' },
        { to: 'n', from: '[ÑŃŅŇ]' },
        { to: 'o', from: '[ÒÓÔÕÖØŌŎŐỌỎỐỒỔỖỘỚỜỞỠỢǪǬƠ]' },
        { to: 'oe', from: '[Œ]' },
        { to: 'p', from: '[ṕ]' },
        { to: 'r', from: '[ŔŖŘ]' },
        { to: 's', from: '[ßŚŜŞŠȘ]' },
        { to: 't', from: '[ŢŤ]' },
        { to: 'u', from: '[ÙÚÛÜŨŪŬŮŰŲỤỦỨỪỬỮỰƯ]' },
        { to: 'w', from: '[ẂŴẀẄ]' },
        { to: 'x', from: '[ẍ]' },
        { to: 'y', from: '[ÝŶŸỲỴỶỸ]' },
        { to: 'z', from: '[ŹŻŽ]' }
    ];
    if (!isUrl) {
        sets.push({ to: '-', from: "[·/_,:;']" });
    }
    sets.forEach(function (set) {
        text = text.replace(new RegExp(set.from, 'gi'), set.to);
    });
    text = text.replace(/[^ -~]/gi, '');
    return text;
}
/**
 * Clean slugs by removing spaces, invalid characters and dashes
 * @param slug - the slug you wanna clean
 */
function slugify(slug) {
    slug = slug.replace(/^\s+|\s+$/g, ''); // trim
    slug = slug.toLowerCase();
    // remove accents
    slug = transformToLatin(slug);
    slug = slug
        .replace(/[^a-z0-9 -]/g, '-') // invalid chars to -
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes
    return slug;
}
function t(key, language) {
    var _a;
    if (language === 'en') {
        return key;
    }
    else {
        return (_a = translations[key]) !== null && _a !== void 0 ? _a : key;
    }
}
/**
 * Decrypt accessToken (Copied from app-shell-v2/src/helpers/helper.ts:245 )
 * @param token accessToken (Example: user.accessToken from homepage)
 * @returns decrypted accessToken
 */
function decrypt(token) {
    if (typeof atob === 'function') {
        return atob(atob(token));
    }
    var nodeAtob = function (str) {
        return Buffer.from(str, 'base64').toString('binary');
    };
    return nodeAtob(nodeAtob(token));
}
function encrypt(token) {
    if (typeof btoa === 'function') {
        return btoa(btoa(token)).replace(/=/g, '');
    }
    var nodeBtoa = function (str) {
        return Buffer.from(str).toString('base64');
    };
    return nodeBtoa(nodeBtoa(token));
}
var detectPage = function () {
    if (typeof window === undefined) {
        return 'search-result';
    }
    var url = window.location.href;
    for (var i = 0; i < pathPage.length; i++) {
        var pathItem = pathPage[i];
        var checkPath = pathItem.path.filter(function (path) { return url.indexOf(path) >= 0; });
        if (checkPath.length > 0) {
            return pathItem.page;
        }
    }
    return 'homepage';
};
var filterHTMLTag = function (text) {
    if (text === void 0) { text = ''; }
    return text !== undefined && text !== null ? text.replace(/<\/?[^>]+(>|$)/g, '') : '';
};
function generateJobUrl(jobId, alias, lang, domain, utmString) {
    if (lang === void 0) { lang = 'en'; }
    if (domain === void 0) { domain = ''; }
    if (utmString === void 0) { utmString = ''; }
    var linkJob = domain + '/' + alias + '-' + jobId;
    if (lang === 'en') {
        linkJob += '-jd';
    }
    else {
        linkJob += '-jv';
    }
    if (utmString.length > 0) {
        linkJob += '?' + utmString;
    }
    return linkJob;
}
var compareVariable = function (val1, val2) {
    return JSON.stringify(val1) === JSON.stringify(val2);
};
function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!result) {
        return null;
    }
    var _a = {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    }, r = _a.r, g = _a.g, b = _a.b;
    return {
        r: r,
        g: g,
        b: b,
        toString: function () {
            return [r, g, b].join(',');
        }
    };
}
function isDifferentArrayData(arr1, arr2) {
    if (!Array.isArray(arr1) || !Array.isArray(arr2)) {
        console.trace("[isDifferentArrayData] Invalid input data ".concat(arr1, " ").concat(arr2));
        return true;
    }
    return arr1.some(function (item) { return !arr2.includes(item); }) || arr2.some(function (item) { return !arr1.includes(item); });
}
var sortArray = function (options, type, objectKey) {
    if (type === void 0) { type = 'asc'; }
    if (objectKey === void 0) { objectKey = ''; }
    if (options.length > 0) {
        switch (typeof options[0]) {
            case 'number':
                return options.sort(function (a, b) { return (type === 'asc' ? a - b : b - a); });
            case 'string':
                return options.sort(function (a, b) {
                    if (transformToLatin(a) < transformToLatin(b)) {
                        return type === 'asc' ? 1 : -1;
                    }
                    if (transformToLatin(a) > transformToLatin(b)) {
                        return type === 'asc' ? -1 : 1;
                    }
                    return 0;
                });
            case 'object': {
                var firstObject = options[0];
                switch (typeof firstObject[objectKey]) {
                    case 'number':
                        return options.sort(function (a, b) {
                            return type === 'asc' ? a[objectKey] - b[objectKey] : b[objectKey] - a[objectKey];
                        });
                    case 'string':
                        return options.sort(function (a, b) {
                            if (transformToLatin(a[objectKey]) < transformToLatin(b[objectKey])) {
                                return type === 'asc' ? -1 : 1;
                            }
                            if (transformToLatin(a[objectKey]) > transformToLatin(b[objectKey])) {
                                return type === 'asc' ? 1 : -1;
                            }
                            return 0;
                        });
                    default:
                        return [];
                }
            }
            default:
                return [];
        }
    }
    else {
        return [];
    }
};
var fixedNumber = function (number, rounding) {
    if (rounding === void 0) { rounding = 0.5; }
    var numb = Number(number);
    if (numb > 0) {
        var plusNumb = Math.abs(numb - Math.floor(numb)) < rounding ? 0 : 1;
        return Math.floor(numb) + plusNumb;
    }
    else {
        var plusNumb = Math.abs(numb - Math.ceil(numb)) < rounding ? 0 : 1;
        return Math.ceil(numb) - plusNumb;
    }
};
var textToLatin = function (text) {
    text = text.toString().toLowerCase().trim();
    var sets = [
        { to: 'a', from: '[ÀÁÂÃÄÅÆĀĂĄẠẢẤẦẨẪẬẮẰẲẴẶἀ]' },
        { to: 'c', from: '[ÇĆĈČ]' },
        { to: 'd', from: '[ÐĎĐÞ]' },
        { to: 'e', from: '[ÈÉÊËĒĔĖĘĚẸẺẼẾỀỂỄỆ]' },
        { to: 'g', from: '[ĜĞĢǴ]' },
        { to: 'h', from: '[ĤḦ]' },
        { to: 'i', from: '[ÌÍÎÏĨĪĮİỈỊ]' },
        { to: 'j', from: '[Ĵ]' },
        { to: 'ij', from: '[Ĳ]' },
        { to: 'k', from: '[Ķ]' },
        { to: 'l', from: '[ĹĻĽŁ]' },
        { to: 'm', from: '[Ḿ]' },
        { to: 'n', from: '[ÑŃŅŇ]' },
        { to: 'o', from: '[ÒÓÔÕÖØŌŎŐỌỎỐỒỔỖỘỚỜỞỠỢǪǬƠ]' },
        { to: 'oe', from: '[Œ]' },
        { to: 'p', from: '[ṕ]' },
        { to: 'r', from: '[ŔŖŘ]' },
        { to: 's', from: '[ßŚŜŞŠȘ]' },
        { to: 't', from: '[ŢŤ]' },
        { to: 'u', from: '[ÙÚÛÜŨŪŬŮŰŲỤỦỨỪỬỮỰƯ]' },
        { to: 'w', from: '[ẂŴẀẄ]' },
        { to: 'x', from: '[ẍ]' },
        { to: 'y', from: '[ÝŶŸỲỴỶỸ]' },
        { to: 'z', from: '[ŹŻŽ]' }
    ];
    sets.forEach(function (set) {
        text = text.replace(new RegExp(set.from, 'gi'), set.to);
    });
    return text;
};
function checkIfEmailInString(text) {
    var regex = /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
    return regex.test(text);
}
var addrToNumber = function (addr) {
    return addr.split('.').reduce(function (acc, cur, i) { return (acc += Number(cur) << ((3 - i) * 8)); }, 0);
};
var subnetMaskToNumber = function (mask) {
    return (0xffffffff << (32 - Number(mask))) & 0xffffffff;
};
var isIPv4FromGoogle = function (userIP) {
    var googleBotIPRange = [
        '66.249.64.0/27',
        '66.249.64.128/27',
        '66.249.64.160/27',
        '66.249.64.192/27',
        '66.249.64.224/27',
        '66.249.64.32/27',
        '66.249.64.64/27',
        '66.249.64.96/27',
        '66.249.65.0/27',
        '66.249.65.128/27',
        '66.249.65.160/27',
        '66.249.65.192/27',
        '66.249.65.224/27',
        '66.249.65.32/27',
        '66.249.65.64/27',
        '66.249.65.96/27',
        '66.249.66.0/27',
        '66.249.66.128/27',
        '66.249.66.192/27',
        '66.249.66.32/27',
        '66.249.66.64/27',
        '66.249.68.0/27',
        '66.249.68.32/27',
        '66.249.68.64/27',
        '66.249.69.0/27',
        '66.249.69.128/27',
        '66.249.69.160/27',
        '66.249.69.192/27',
        '66.249.69.224/27',
        '66.249.69.32/27',
        '66.249.69.64/27',
        '66.249.69.96/27',
        '66.249.70.0/27',
        '66.249.70.128/27',
        '66.249.70.160/27',
        '66.249.70.192/27',
        '66.249.70.224/27',
        '66.249.70.32/27',
        '66.249.70.64/27',
        '66.249.70.96/27',
        '66.249.71.0/27',
        '66.249.71.128/27',
        '66.249.71.160/27',
        '66.249.71.192/27',
        '66.249.71.32/27',
        '66.249.71.64/27',
        '66.249.71.96/27',
        '66.249.72.0/27',
        '66.249.72.128/27',
        '66.249.72.160/27',
        '66.249.72.192/27',
        '66.249.72.224/27',
        '66.249.72.32/27',
        '66.249.72.64/27',
        '66.249.72.96/27',
        '66.249.73.0/27',
        '66.249.73.128/27',
        '66.249.73.160/27',
        '66.249.73.192/27',
        '66.249.73.224/27',
        '66.249.73.32/27',
        '66.249.73.64/27',
        '66.249.73.96/27',
        '66.249.74.0/27',
        '66.249.74.32/27',
        '66.249.74.64/27',
        '66.249.74.96/27',
        '66.249.75.0/27',
        '66.249.75.128/27',
        '66.249.75.160/27',
        '66.249.75.192/27',
        '66.249.75.224/27',
        '66.249.75.32/27',
        '66.249.75.64/27',
        '66.249.75.96/27',
        '66.249.76.0/27',
        '66.249.76.128/27',
        '66.249.76.160/27',
        '66.249.76.192/27',
        '66.249.76.224/27',
        '66.249.76.32/27',
        '66.249.76.64/27',
        '66.249.76.96/27',
        '66.249.77.0/27',
        '66.249.77.128/27',
        '66.249.77.32/27',
        '66.249.77.64/27',
        '66.249.77.96/27',
        '66.249.79.0/27',
        '66.249.79.128/27',
        '66.249.79.160/27',
        '66.249.79.192/27',
        '66.249.79.224/27',
        '66.249.79.32/27',
        '66.249.79.64/27',
        '66.249.79.96/27',
        '66.249.91.0/27'
    ];
    var isFromGoogle = false;
    // Loop through all CIDR from google IPv4 to find match IP
    googleBotIPRange.map(function (cidr) {
        var _a = cidr.split('/'), networkAddr = _a[0], subnetMask = _a[1];
        var match = (addrToNumber(userIP) & subnetMaskToNumber(subnetMask)) === addrToNumber(networkAddr);
        if (match) {
            isFromGoogle = true;
        }
    });
    return isFromGoogle;
};
// For IPv6
var isIPv6FromGoogle = function (userIP) {
    var isFromGoogle = false;
    // TODO: Loop through all CIDR from google IPv6 to find match IP
    // IPv6 is not support yet
    return isFromGoogle;
};
/**
 * Check user IP address if it is a bot or not
 * @param userIP string
 */
var isIPFromGoogleBot = function (userIP) {
    if (userIP.length === 0) {
        return false;
    }
    var isFromGoogle = false;
    for (var i = 0; i < userIP.length; i++) {
        if (!userIP[i]) {
            continue;
        }
        var isIPv4 = userIP[i].indexOf('.') > 0;
        var userIPSplitted = isIPv4 ? userIP[i].split('.') : userIP[i].split(':');
        if (isIPv4 && userIPSplitted[0] === '66' && userIPSplitted[1] === '249') {
            isFromGoogle = isIPv4FromGoogle(userIP[i]);
        }
        else if (!isIPv4 &&
            userIPSplitted.length > 1 &&
            userIPSplitted[0] === '2001' &&
            userIPSplitted[1] === '4860' &&
            userIPSplitted[2] === '4801') {
            isFromGoogle = isIPv6FromGoogle(userIP[i]);
        }
    }
    return isFromGoogle;
};
/**
 * Check a user-agent if it's a robot
 * @param userAgent
 */
var isRobot = function (userAgent, userIP) {
    var botUserAgents = [
        'googlebot',
        'google-structured-data-testing-tool',
        'bingbot',
        'linkedinbot',
        'mediapartners-google',
        'apis-google',
        'feedfetcher-google',
        'googlebot-image',
        'storebot-google',
        'adsBot-google-mobile',
        'adsBot-google-mobile-apps',
        'adsBot-google',
        'googlebot-news',
        'googlebot-video',
        'storebot-google'
    ];
    var currentUserAgent = userAgent.toLowerCase();
    var isBot = botUserAgents.some(function (item) {
        return currentUserAgent.includes(item);
    });
    // Detect IP from Google bot
    // Only call detect IP when isBot = false (For better performance)
    if (!isBot && userIP !== undefined) {
        isBot = isIPFromGoogleBot(userIP);
    }
    return isBot;
};
var isCompanyWhitelisted = function (props) {
    var companyId = props.companyId, appMode = props.appMode;
    // staging
    if (appMode === 'staging') {
        return NAVIGOS_COMPANY_ID.staging.includes(companyId);
    }
    // release
    if (appMode === 'release') {
        return NAVIGOS_COMPANY_ID.release.includes(companyId);
    }
    // production
    return NAVIGOS_COMPANY_ID.production.includes(companyId);
};
/**
 * Return Random UID - @SangNguyen
 * @returns unique id (Ex: rand-bdc08475-7af48ce5-9da0d3be)
 */
var randomId = function () {
    var s4 = function () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    return "rand-".concat(s4()).concat(s4(), "-").concat(s4()).concat(s4(), "-").concat(s4()).concat(s4());
};
/**
 * Check values change
 * @param firstLocations first item locations need to compare
 * @param secondLocations second item locations need to compare
 * @returns boolean true when 2 variables is different
 */
function isLocationChanged(firstLocations, secondLocations) {
    var _a, _b, _c, _d, _e, _f;
    // parents is have more or less item
    if (firstLocations.length !== secondLocations.length) {
        return true;
    }
    var _loop_1 = function (i) {
        var currentItem = firstLocations[i];
        var filtered = secondLocations.filter(function (item) { return (item === null || item === void 0 ? void 0 : item.parentId) === (currentItem === null || currentItem === void 0 ? void 0 : currentItem.parentId); });
        // length match then detect child item
        // second item doesn't have item that first item have
        if (filtered.length === 0) {
            return { value: true };
        }
        // Child is have more or less selected
        if (((_b = (_a = filtered[0]) === null || _a === void 0 ? void 0 : _a.childrenIds) === null || _b === void 0 ? void 0 : _b.length) !== ((_c = currentItem === null || currentItem === void 0 ? void 0 : currentItem.childrenIds) === null || _c === void 0 ? void 0 : _c.length)) {
            return { value: true };
        }
        var _loop_2 = function (j) {
            var childId = currentItem === null || currentItem === void 0 ? void 0 : currentItem.childrenIds[j];
            var filteredChild = (_f = (_e = filtered[0]) === null || _e === void 0 ? void 0 : _e.childrenIds) === null || _f === void 0 ? void 0 : _f.filter(function (childItemId) { return childItemId === childId; });
            if (filteredChild.length === 0) {
                return { value: true };
            }
        };
        // length does match need to compare child
        for (var j = 0; j < ((_d = currentItem === null || currentItem === void 0 ? void 0 : currentItem.childrenIds) === null || _d === void 0 ? void 0 : _d.length); j++) {
            var state_2 = _loop_2(j);
            if (typeof state_2 === "object")
                return state_2;
        }
    };
    // Check districts
    for (var i = 0; i < firstLocations.length; i++) {
        var state_1 = _loop_1(i);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    return false;
}
function formatSalary(_a, isShowSalary, language) {
    var min = _a.min, max = _a.max;
    if (!isShowSalary) {
        return language === 'en' ? 'Negotiate' : 'Thương Lượng';
    }
    if (min > 0 && max > 0) {
        return "$".concat(min, " - $").concat(max);
    }
    if (min > 0) {
        return "".concat(language === 'en' ? 'From' : 'Từ', " $").concat(min);
    }
    if (max > 0) {
        return "".concat(language === 'en' ? 'Up To' : 'Tới', " $").concat(max);
    }
    return '';
}
function isVietnamese(text) {
    return /[\u0300-\u036f]|[đĐ]/gi.test(text.normalize('NFD'));
}
function createTranslator(_a) {
    var translations = _a.translations, defaultLanguage = _a.defaultLanguage, currentLanguage = _a.currentLanguage;
    var firstEntry = null;
    var detectedDefaultLanguage = defaultLanguage;
    if (!detectedDefaultLanguage) {
        for (var _i = 0, _b = Object.entries(translations); _i < _b.length; _i++) {
            var _c = _b[_i], keyText = _c[0], valueText = _c[1];
            if (!firstEntry) {
                firstEntry = [keyText, valueText];
            }
            if (isVietnamese(keyText)) {
                detectedDefaultLanguage = ELanguage.VI;
                break;
            }
            if (isVietnamese(valueText)) {
                detectedDefaultLanguage = ELanguage.EN;
                break;
            }
        }
    }
    if (!detectedDefaultLanguage) {
        console.warn("Cannot detect default language from provided dictionary. First entry is \"".concat(firstEntry, "\""));
        console.warn("Fallback to English as default language");
        detectedDefaultLanguage = ELanguage.EN;
    }
    return function (text, replacement) {
        if (!text) {
            return '';
        }
        var matchedText = currentLanguage === detectedDefaultLanguage ? text : translations[text];
        if (!matchedText) {
            matchedText = text;
        }
        return replacement
            ? Object.keys(replacement).reduce(function (acc, key) { return acc.replace(new RegExp(key, 'g'), replacement[key].toString()); }, matchedText)
            : matchedText;
    };
}
// this fnc using when not using state in input => using custom debounce
// for example in Form management
function debounceHandler(func, delay) {
    var timer;
    return function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timer);
        timer = setTimeout(function () {
            func.apply(_this, args);
        }, delay);
    };
}
function attachQueryParamToUrl(url, params) {
    if (!Object.keys(params).length) {
        return url;
    }
    var urlEntity = new URL(url);
    for (var _i = 0, _a = Object.entries(params); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (value === undefined) {
            urlEntity.searchParams.delete(key);
            continue;
        }
        if ((typeof value === 'object' && !Array.isArray(value)) || Number.isNaN(value)) {
            continue;
        }
        urlEntity.searchParams.set(key, value);
    }
    return urlEntity.toString();
}
function extractFileNameAndExtension(fileName) {
    var lastDotIndex = fileName === null || fileName === void 0 ? void 0 : fileName.lastIndexOf('.');
    var name = fileName === null || fileName === void 0 ? void 0 : fileName.slice(0, lastDotIndex);
    var extension = fileName === null || fileName === void 0 ? void 0 : fileName.slice(lastDotIndex + 1);
    return [name, extension];
}
function downloadAttachFile(params) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var resumeId, accessToken, msBaseUrl, fileName, _b, downloadRequest, _c, body, _d, onOpenOrDownload_1, docExtensions, pdfMineType, API_DOWNLOAD_CV, requestOptions, response, blob, file_1, _e, extractedFilename_1, fileExtension_1, responseMineType, requestState, download, openNewTab, ex_1;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 3, , 4]);
                    resumeId = params.resumeId, accessToken = params.accessToken, msBaseUrl = params.msBaseUrl, fileName = params.fileName, _b = params.downloadRequest, downloadRequest = _b === void 0 ? 'all' : _b, _c = params.body, body = _c === void 0 ? null : _c, _d = params.onOpenOrDownload, onOpenOrDownload_1 = _d === void 0 ? null : _d;
                    if (!accessToken) {
                        return [2 /*return*/];
                    }
                    docExtensions = ['docx', 'doc'];
                    pdfMineType = 'application/pdf';
                    API_DOWNLOAD_CV = "".concat(msBaseUrl, "/api-gateway/v1.0/profile/resume-file/").concat(resumeId);
                    requestOptions = {
                        method: 'POST',
                        headers: {
                            Authorization: "Bearer ".concat(accessToken)
                        }
                    };
                    if (body !== null) {
                        requestOptions.headers['Content-Type'] = 'application/json';
                        requestOptions.body = JSON.stringify(body);
                    }
                    return [4 /*yield*/, fetch(API_DOWNLOAD_CV, requestOptions)];
                case 1:
                    response = _f.sent();
                    return [4 /*yield*/, response.blob()];
                case 2:
                    blob = _f.sent();
                    file_1 = window.URL.createObjectURL(blob);
                    _e = extractFileNameAndExtension(fileName), extractedFilename_1 = _e[0], fileExtension_1 = _e[1];
                    responseMineType = (_a = response === null || response === void 0 ? void 0 : response.headers) === null || _a === void 0 ? void 0 : _a.get('Content-Type');
                    requestState = downloadRequest;
                    if (docExtensions.includes(fileExtension_1) && responseMineType !== pdfMineType) {
                        requestState = 'download';
                    }
                    download = function () {
                        var a = document.createElement('a');
                        a.href = file_1;
                        a.download = transformToLatin("".concat(extractedFilename_1, ".").concat(fileExtension_1));
                        a.click();
                        onOpenOrDownload_1 && onOpenOrDownload_1();
                    };
                    openNewTab = function () {
                        onOpenOrDownload_1 && onOpenOrDownload_1();
                        if (typeof window === 'undefined') {
                            return;
                        }
                        window.open(file_1, '_blank');
                    };
                    switch (requestState) {
                        case 'download':
                            download();
                            break;
                        case 'new-window':
                            openNewTab();
                            break;
                        case 'all':
                        default:
                            download();
                            openNewTab();
                            break;
                    }
                    return [3 /*break*/, 4];
                case 3:
                    ex_1 = _f.sent();
                    console.error('Error when download file', ex_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
var ACCESS_TOKEN_LENGTH = 86;
var detectEncryptAccessToken = function (accessToken) {
    // If access token length is larger than 86 characters
    // then it should be decrypted
    return accessToken.length === ACCESS_TOKEN_LENGTH ? accessToken : decrypt(accessToken !== null && accessToken !== void 0 ? accessToken : '');
};
function getiOSVersion() {
    if (typeof window === 'undefined') {
        return -2;
    }
    var userAgent = window.navigator.userAgent;
    var match = userAgent.match(/(iPad|iPhone|iPod)\s+OS\s+(\d+)/);
    if (!match) {
        // Not iOS
        return -2;
    }
    if (match && match[2]) {
        var versionInNumber = Number(match[2]);
        if (isNaN(versionInNumber)) {
            return -1;
        }
        return versionInNumber;
    }
    // -1 is standing for Unknown
    return -1;
}
function isPrivateIP(ip) {
    // Localhost range
    var privateRanges = [
        { start: '10.0.0.0', end: '10.255.255.255' },
        { start: '172.16.0.0', end: '172.31.255.255' },
        { start: '192.168.0.0', end: '192.168.255.255' },
        { start: '127.0.0.0', end: '127.255.255.255' }
    ];
    var ipToNumber = function (ip) {
        return ip.split('.').reduce(function (acc, octet) { return acc * 256 + parseInt(octet, 10); }, 0);
    };
    var ipNumber = ipToNumber(ip.trim());
    return privateRanges.some(function (range) {
        return ipNumber >= ipToNumber(range.start) && ipNumber <= ipToNumber(range.end);
    });
}
var filterPrivateIP = function (ipList) {
    // Filter out all Fortiweb IP
    var filteredNotFortiweb = ipList.filter(function (ip) { return !FORTIWEB_IP.includes(ip); });
    // Filter out all private IP
    var filteredPublic = filteredNotFortiweb.filter(function (ip) { return !isPrivateIP(ip); });
    if (filteredPublic.length > 0) {
        return filteredPublic;
    }
    // If no public IP remain then return filtered not fortiweb
    return filteredNotFortiweb;
};
/*
 * Forked of https://github.com/epoberezkin/fast-deep-equal
 * */
function deepEqual(a, b) {
    if (a === b) {
        return true;
    }
    if (typeof a !== typeof b) {
        return false;
    }
    if (a && b && typeof a === 'object' && typeof b === 'object') {
        if (a.constructor !== b.constructor) {
            return false;
        }
        var length_1, i = void 0;
        if (Array.isArray(a)) {
            length_1 = a.length;
            if (length_1 !== b.length) {
                return false;
            }
            for (i = length_1; i-- !== 0;) {
                if (!deepEqual(a[i], b[i])) {
                    return false;
                }
            }
            return true;
        }
        var keys = Object.keys(a);
        length_1 = keys.length;
        if (length_1 !== Object.keys(b).length) {
            return false;
        }
        for (i = length_1; i-- !== 0;) {
            if (!{}.hasOwnProperty.call(b, keys[i])) {
                return false;
            }
        }
        for (i = length_1; i-- !== 0;) {
            var key = keys[i];
            if (key === '_owner' && a.$$typeof) {
                continue;
            }
            if (!deepEqual(a[key], b[key])) {
                return false;
            }
        }
        return true;
    }
    return a !== a && b !== b;
}
function filterObjectArrayBasedOnObjectArray(targetArray, filterArray, key, omit) {
    var filterArrayKeys = filterArray.map(function (item) { return item[key]; });
    if (omit && omit.length > 0) {
        filterArrayKeys = filterArrayKeys.concat(omit);
    }
    return targetArray.filter(function (item) { return !filterArrayKeys.includes(item[key]); });
}
function quickFilterByKeywords(options, keywords, fieldSearch) {
    var cpOptions = __spreadArray([], options, true);
    return cpOptions.filter(function (option) {
        if (keywords === '') {
            return true;
        }
        return transformToLatin(option[fieldSearch]).indexOf(transformToLatin(keywords)) > -1;
    });
}
function locationsMappingHelperForMultiLevelSelect(countries, cities, districts, langcode) {
    var mappedVietNamCities = [];
    cities.forEach(function (city) {
        if (districts[city.id]) {
            var result = __assign(__assign({}, city), { name: langcode === ELanguage.VI ? city.name : city.nameEn, children: districts[city.id].map(function (district) { return (__assign(__assign({}, district), { name: langcode === ELanguage.VI ? district.name : district.nameEn })); }) });
            mappedVietNamCities.push(result);
        }
        else {
            mappedVietNamCities.push(__assign(__assign({}, city), { name: langcode === ELanguage.VI ? city.name : city.nameEn }));
        }
    });
    mappedVietNamCities = mappedVietNamCities.filter(function (city) { return city.id !== INTERNATIONAL_CITY_ID; });
    var mappedCountries = [];
    countries.forEach(function (country) {
        if (country.id === VIETNAM_COUNTRY_ID) {
            var result = __assign(__assign({}, country), { name: langcode === ELanguage.VI ? country.name : country.nameEn, children: mappedVietNamCities });
            mappedCountries.push(result);
        }
        else {
            var result = __assign(__assign({}, country), { name: langcode === ELanguage.VI ? country.name : country.nameEn });
            mappedCountries.push(result);
        }
    });
    return mappedCountries;
}
/**
 * Deeply merge two or more objects
 * @param  {...object} objects - Objects to merge
 */
function deepMerge() {
    var objects = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objects[_i] = arguments[_i];
    }
    var target = {};
    var merge = function (obj) {
        for (var prop in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                if (obj[prop] === null || obj[prop] === undefined) {
                    continue;
                }
                if (typeof obj[prop] === 'object' && !Array.isArray(obj[prop])) {
                    target[prop] = deepMerge(target[prop], obj[prop]);
                }
                else if (typeof obj[prop] === 'object' && Array.isArray(obj[prop])) {
                    target[prop] = __spreadArray(__spreadArray([], (target[prop] || []), true), (obj[prop] || []), true);
                }
                else {
                    target[prop] = obj[prop];
                }
            }
        }
    };
    objects.forEach(function (object) { return merge(object); });
    return target;
}

export { ConvertHexToRgbA, addCommaToNumber, attachQueryParamToUrl, checkIfEmailInString, compareVariable, createTranslator, debounceHandler, decrypt, deepEqual, deepMerge, detectEncryptAccessToken, detectPage, downloadAttachFile, encodeKeyword, encrypt, filterHTMLTag, filterInt, filterObjectArrayBasedOnObjectArray, filterPrivateIP, fixedNumber, formatSalary, generateJobUrl, getNumberFromString, getiOSVersion, hexToRgb, isCompanyWhitelisted, isDesktop, isDifferentArrayData, isIPv4FromGoogle, isLocationChanged, isMobile, isPrivateIP, isRobot, isVietnamese, locationsMappingHelperForMultiLevelSelect, quickFilterByKeywords, randomId, slugify, sortArray, t, textToLatin, transformToLatin };
//# sourceMappingURL=helpers.js.map
